import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Page } from "./types";
import ScrollToTop from "./ScrollToTop";
import PageHome from "containers/PageHome/PageHome";
import PropertyListPage from "containers/PageHome/PropertyListPage"
import SiteHeader from "containers/SiteHeader";
import FooterNav from "components/FooterNav";
import useWindowSize from "hooks/useWindowResize";
import PageLogin from "containers/PageLogin/PageLogin";
import PageSignUp from "containers/PageSignUp/PageSignUp";
import ForgetLogin from "containers/ForgetPassword/ForgetPassword";
import SetOtp from "containers/ForgetPassword/otp";
import AccountPage from "containers/AccountPage/AccountPage";
import AccountPass from "containers/AccountPage/AccountPass";
import AddProperty from "containers/PageAddListing1/AddProperty";
import EditProperty from "containers/PageAddListing1/EditProperty";
import VerifyOtp from "components/VerifyOtp";
import MyCalendar from "containers/PageHome/PageBooking"
import Footer from "shared/Footer/Footer";
import ListingStayDetailPage from "containers/ListingDetailPage/ListingStayDetailPage";
import DirecConnects from "containers/AccountPage/DirecConnects";
import Blacklist from "containers/AccountPage/Blacklist";
import DirecCoins from "containers/AccountPage/DirecCoins";
import ReceiptRequests from "containers/AccountPage/ReceiptRequests";

export const pages: Page[] = [
  { path: "/account", component: AccountPage },
  {path:"/direktConnects", component:DirecConnects},
  {path:"/blacklist", component: Blacklist},
  {path:"/direktCoins", component: DirecCoins},
  { path: "/receipt-requests", component: ReceiptRequests},
  { path: "/account-password", component: AccountPass },
  // { path: "/property", component: PropertyListPage },
  { path: "/", component: MyCalendar },
  {path:"/detail",component: ListingStayDetailPage},
  { path: "/properties", component: PageHome },
  { path: "/login", component: PageLogin },
  { path: "/verify", component: VerifyOtp },

  { path: "/signup", component: PageSignUp },
  { path: "/forgot-password", component: ForgetLogin },
  { path: "/verify-otp", component: SetOtp },
  { path: "/add-property", component: AddProperty },
  { path: "/edit-property/:id", component: EditProperty },
];

const MyRoutes = () => {
  let WIN_WIDTH = useWindowSize().width;
  if (typeof window !== "undefined") {
    WIN_WIDTH = WIN_WIDTH || window.innerWidth;
  }
 const isToken = localStorage.getItem("token");

  return (
    <BrowserRouter>
      <ScrollToTop />
    
        <Routes>
        {pages.map(({ component, path }) => {
          const Component = component;
          return (
            <Route
              key={path}
              element={
                <>
                  <div className="page-container flex flex-col min-h-screen min-w-screen">
                    <SiteHeader />
                    <div
                      className={`content flex-grow h-full flex`}
                    > 
                      <Component />
                    </div>

                    <Footer />
                  </div>
                </>
              }
              path={path}
            />
          );
        })}
      </Routes>
      {WIN_WIDTH < 768 && <FooterNav />}
    </BrowserRouter>
  );
};

export default MyRoutes;
